import React from 'react';
import { useLocation } from 'react-router-dom';

// BrowserRouter doesn't reset scroll position on navigation (unlike a full
// page load), so route changes land wherever the previous page left off.
//
// A link into another page's anchor (/faq#what-happens-to-my-existing-content)
// lands on that anchor instead: prerendered pages already have the target in
// the DOM when this runs. Without a target, fall back to the top.
//
// A router link to an anchor on the current page (the CTA ladder's
// /#community-calls, clicked on the home page, or clicked again) scrolls
// there too; `key` changes on every navigation, even a same-URL replace.
// Native href="#…" jumps (table-of-contents links, /pricing's #plans, the
// skip link) also reach the router via popstate, so this runs for them
// too: it scrolls to the element the browser already jumped to, and on
// Back the browser restores the reader's position afterwards.
const ScrollToTop = () => {
  const { pathname, hash, key } = useLocation();

  React.useEffect(() => {
    let target;
    try {
      target = hash && document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch {
      target = null;
    }
    if (target)
      target.scrollIntoView();
    else
      window.scrollTo(0, 0);
  }, [pathname, hash, hash ? key : '']);

  return null;
};

export default ScrollToTop;
